import { createMongoAbility } from '@casl/ability';
import type {
  AppAbility,
  AppAction,
  AppSubject,
} from '@tronche2tek/shared-types';
import { createContext } from 'react';

export function emptyAbility(): AppAbility {
  return createMongoAbility<[AppAction, AppSubject]>([]);
}

export const AbilityContext = createContext<AppAbility>(emptyAbility());
